import React, { Component } from "react";
import Board from "./Board/Board.js";
import Menu from "./Menu/Menu.js";

// Popups
import PopupOutOfLevels from "./Popup/PopupOutOfLevels.js";
import PopupGetHints from "./Popup/PopupGetHints.js";
import PopupDownloadApp from "./Popup/PopupDownloadApp.js";
import PopupYouWin from "./Popup/PopupYouWin.js";
import PopupRateApp from "./Popup/PopupRateApp.js";

import LocalStorage from "./LocalStorage.js";
import Constants from "./Constants.js";
import Sounds from "./Sounds.js";
import PlatformTest from "./PlatformTest.js";

// Prevent scrolling of root elemenet
document.addEventListener("DOMContentLoaded", (e) => {
    document.getElementById('root').addEventListener("touchmove", (e) => {
        e.preventDefault();
    }, false);
    document.body.addEventListener("touchmove", (e) => {
        e.preventDefault();
    }, false);
    document.documentElement.addEventListener("touchmove", (e) => {
        e.preventDefault();
    }, false);
    document.addEventListener("touchmove", (e) => {
        e.preventDefault();
    }, false);
}, false);



class App extends Component {

    constructor(props) {
        super(props);

        /*
        Local storage
        */

        // Get local storage data
        let data = LocalStorage.getData();
        data.hintsRemaining = 15;

        // State
        this.state = {
            data: data,
            tutorialMode: (data.levelsBeat.length === 0),
            // In-app purchase prices
            prices: {
                levels: undefined,
                hints1: undefined,
                hints2: undefined,
                hints3: undefined,
            },
            showingCoolmathSplash: false,
        }

        // Show and hide menu
        this.showMenu = this.showMenu.bind(this);
        this.hideMenu = this.hideMenu.bind(this);

        // Update local storage data and state
        this.updateData = this.updateData.bind(this);

        // Refs
        this.board = React.createRef();
        this.menu = React.createRef();

        // Popup refs
        this.popupOutOfLevels = React.createRef();
        this.popupGetHints = React.createRef();
        this.popupDownloadApp = React.createRef();
        this.popupYouWin = React.createRef();
        this.popupRateApp = React.createRef();
    }

    initStore() {
        if (window.store) {

            // window.store.verbosity = window.store.DEBUG;

            // Handle purchases
            window.store.when('hints1')
                .approved((product) => {
                    Sounds.play('purchaseSuccess');
                    let data = LocalStorage.getData();
                    data.hintsRemaining = data.hintsRemaining + Constants.hintAmounts[0];
                    this.updateData(data)
                    product.finish();
                });
            window.store.when('hints2')
                .approved((product) => {
                    Sounds.play('purchaseSuccess');
                    let data = LocalStorage.getData();
                    data.hintsRemaining = data.hintsRemaining + Constants.hintAmounts[1];
                    this.updateData(data)
                    product.finish();
                });
            window.store.when('hints3')
                .approved((product) => {
                    Sounds.play('purchaseSuccess');
                    let data = LocalStorage.getData();
                    data.hintsRemaining = data.hintsRemaining + Constants.hintAmounts[2];
                    this.updateData(data)
                    product.finish();
                });
            window.store.when('levels')
                .approved((product) => {
                    Sounds.play('purchaseSuccess');
                    let data = LocalStorage.getData();
                    data.paidLevelsUnlocked = true;
                    this.updateData(data)
                    product.finish();
                });
            window.store.when('removenonoptionalads')
                .approved((product) => {
                    Sounds.play('purchaseSuccess');
                    let data = LocalStorage.getData();
                    data.removedAds = true;
                    this.updateData(data)
                    product.finish();
                });

            // Register products
            window.store.register({
                id: "hints1",
                alias: "5 Hints",
                type: window.store.CONSUMABLE
            });
            window.store.register({
                id: "hints2",
                alias: "15 Hints",
                type: window.store.CONSUMABLE
            });
            window.store.register({
                id: "hints3",
                alias: "50 Hints",
                type: window.store.CONSUMABLE
            });
            window.store.register({
                id: "levels",
                alias: "Unlock All Levels",
                type: window.store.NON_CONSUMABLE
            });
            window.store.register({
                id: "removenonoptionalads",
                alias: "Remove Ads",
                type: window.store.NON_CONSUMABLE
            });

            // Store is ready
            window.store.ready(() => {
                const prices = {
                    hints1: window.store.get('hints1').price,
                    hints2: window.store.get('hints2').price,
                    hints3: window.store.get('hints3').price,
                    levels: window.store.get('levels').price,
                }
                this.setState({prices: prices});
            });

            // Refresh store
            window.store.refresh();
        }
    }

    componentDidMount() {
        // Initialize store
        this.initStore();

        if (Constants.coolmathVersion) {
            document.title = 'Word Surge – Play it now at CoolmathGames.com';
            this.setState({ showingCoolmathSplash: true });

            setTimeout(() => {
                this.setState({ showingCoolmathSplash: false });
            }, 1500);
        }

        // Hide loading overlay
        document.getElementById('LoadingOverlay').style.opacity = '0';

        // Show board
        this.board.current.showBoard();

        // If the user is on iOS or Android
        let isMobile = PlatformTest.ios() || PlatformTest.android();
        // Not already app version
        let isNotApp = !Constants.appVersion;
        // If the user is new
        let isNew = (this.state.data.levelsBeat.length === 0);

        // If the user is new and on mobile
        if (isMobile && isNew && isNotApp && !Constants.coolmathVersion) {
            this.popupDownloadApp.current.show();
        }
    }

    showMenu() {
        this.board.current.hideBoard();
        this.menu.current.showMenu();
    }
    hideMenu() {
        this.board.current.showBoard();
        this.menu.current.hideMenu();
    }

    updateData(data) {
        LocalStorage.setData(data);
        this.setState({data: data});
    }

    render() {
        return (
            <div>
                <Board
                    ref={this.board}
                    data={this.state.data}
                    tutorialMode={this.state.tutorialMode}
                    onMenuOpen={() => {
                        this.showMenu();
                    }}
                    onGetHints={() => {
                        if (Constants.appVersion) {
                            this.popupGetHints.current.show();
                        }
                        else {
                            this.popupDownloadApp.current.show();
                        }
                    }}
                    onUpdateData={(data) => {
                        this.updateData(data);
                    }}
                    onOutOfLevels={() => {
                        if (!Constants.coolmathVersion)
                            this.popupOutOfLevels.current.show();
                    }}
                    onRequestRating={() => {
                        if (PlatformTest.ios()) {
                            this.popupRateApp.current.show();
                        }
                    }}
                    onWin={() => {
                        this.popupYouWin.current.show();
                    }}
                />
                <Menu
                    ref={this.menu}
                    data={this.state.data}
                    prices={this.state.prices}
                    onLevelSelect={(level) => {
                        // Update local storage
                        let data = LocalStorage.getData();
                        data.currentLevel = level;
                        this.updateData(data);

                        // Update board states and close menu
                        this.setState({level: level}, () => {
                            this.board.current.updateLevelStates(level, () => {
                                this.hideMenu();
                            });
                        });

                        // Coolmath game event
                        if (typeof window.top.cmgGameEvent === 'function') {
                            window.top.cmgGameEvent('start', (level + 1).toString())
                        }
                    }}
                    onTutorialInit={() => {
                        // Start tutorial
                        this.board.current.initTutorial(() => {
                            this.hideMenu();
                        });
                    }}
                    onGetHints={() => {
                        this.popupGetHints.current.show();
                    }}
                    onRateApp={() => {
                        // Old: show popup
                        //this.popupRateApp.current.show();

                        // If LaunchReview exists
                        if (window.LaunchReview) {
                            // If in-app rating is supported, show the window
                            if (window.LaunchReview.isRatingSupported()) {
                                window.LaunchReview.rating();
                            }
                            // Else, launch the app store and prompt for rating
                            else {
                                window.LaunchReview.launch();
                            }
                        }
                    }}
                    onUpdateData={(data) => {
                        this.updateData(data);
                    }}
                />
                <PopupOutOfLevels
                    ref={this.popupOutOfLevels}
                    data={this.state.data}
                    prices={this.state.prices}
                    onUpdateData={(data) => {
                        this.updateData(data);
                    }}
                />
                <PopupGetHints
                    ref={this.popupGetHints}
                    data={this.state.data}
                    prices={this.state.prices}
                    onUpdateData={(data) => {
                        this.updateData(data);
                    }}
                />
                <PopupDownloadApp
                    ref={this.popupDownloadApp}
                />
                <PopupYouWin
                    ref={this.popupYouWin}
                />
                <PopupRateApp
                    ref={this.popupRateApp}
                    data={this.state.data}
                    onUpdateData={(data) => {
                        this.updateData(data);
                    }}
                />

                {
                    // Coolmath splash screen
                    Constants.coolmathVersion &&
                    <div
                        style={{
                            position: 'fixed',
                            width: '100%',
                            height: '100%',
                            boxSizing: 'border-box',
                            opacity: (this.state.showingCoolmathSplash ? '1' : '0'),
                            pointerEvents: (this.state.showingCoolmathSplash ? 'auto' : 'none'),
                            backgroundImage: 'url(coolmath-splash.png)',
                            backgroundColor: '#242424',
                            backgroundPosition: 'center',
                            backgroundSize: 'contain',
                            backgroundRepeat: 'no-repeat',
                            transition: 'opacity 200ms',
                        }}
                    >
                    </div>
                }
            </div>
        )
    }
}

export default App;
